import { render, staticRenderFns } from "./crearusuario.vue?vue&type=template&id=bf85eb90"
import script from "./crearusuario.vue?vue&type=script&lang=js"
export * from "./crearusuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports